import type { PatientFilter } from './PatientFilter'
import type { DepartmentDTO, WardDTO } from '@/generated'

export interface VitalSignFilters extends Omit<PatientFilter, 'departments' | 'wards'> {
  departments: DepartmentDTO[]
  wards: WardDTO[]
  temperatureRange: readonly (string | number)[]
  lactateRange: readonly (string | number)[]
  pHRange: readonly (string | number)[]
  potassiumRange: readonly (string | number)[]
  hemoglobinRange: readonly (string | number)[]
  heartRateRange: readonly (string | number)[]
  oxygenSaturationRange: readonly (string | number)[]
  vasopressors?: boolean
  dialysis?: boolean
  ventilation?: boolean
  ecmo?: boolean
  impella?: boolean
}

export const arrayVitalSignsFilterKeys = [
  'temperatureRange',
  'lactateRange',
  'pHRange',
  'potassiumRange',
  'hemoglobinRange',
  'heartRateRange',
  'oxygenSaturationRange'
] as const

export const booleanVitalSignsFilterKeys = [
  'vasopressors',
  'dialysis',
  'ventilation',
  'ecmo',
  'impella'
] as const

export type ArrayVitalSignsFilterKeys = (typeof arrayVitalSignsFilterKeys)[number]
export type BooleanVitalSignsFilterKeys = (typeof booleanVitalSignsFilterKeys)[number]
